export enum TreatmentClassification {
  General = 'general',
  Cosmetic = 'cosmetic',
}

export const KNOWLEDGE_BASE_COSMETIC_KEYWORDS = [
  'whiten',
  'bleach',
  'veneer',
  'invisalign',
  'aligner',
  'cosmetic',
  'smile makeover',
  'bonding',
  'implant',
  'all-on-4',
  'all on 4',
  'clearcorrect',
  'suresmile',
  'zoom',
  'botox',
  'gum contour',
] as const;

export function classifyKnowledgeBaseTreatment(input: {
  templateName: string;
  categoryName?: string;
  keyword?: string;
}): TreatmentClassification {
  const fieldsToCheck = [input.templateName, input.categoryName, input.keyword];

  const isCosmeticMatch = fieldsToCheck.some((field) => {
    if (!field) {
      return false;
    }
    const lowerField = field.toLowerCase();
    return KNOWLEDGE_BASE_COSMETIC_KEYWORDS.some((keyword) => lowerField.includes(keyword));
  });

  return isCosmeticMatch
    ? TreatmentClassification.Cosmetic
    : TreatmentClassification.General;
}
